import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { CircularProgress } from '@mui/material';

import {
  getLastUserInfo,
  startMatomo,
  trackEventMatomoVisit,
  trackEventMatomoElementId,
  formatPostUrl,
} from 'js/library/utils/helpers';
import * as S from './styles';

import getFeedPosts from 'js/library/utils/API/apiGetFeedPosts';
import getRelationshipsIds from 'js/library/utils/API/apiGetRelationshipsIds';
import moment from 'moment/moment';
import 'moment/locale/pt-br';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingLists from 'js/containers/Loading/LoadingLists';
import LoginModal from 'js/containers/Login/LoginModal';
import cfac22 from 'js/library/utils/cfac22';

moment.locale('pt-br');

export default function Home() {
  startMatomo();

  const userInfo = getLastUserInfo();

  const [feed, setFeed] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isOpenModalLogin, setIsOpenModalLogin] = useState(false);
  const [isAnonymous, setIsAnonymous] = useState(false);

  useEffect(() => {
    trackEventMatomoVisit('Home');
    document.title = 'Home';

    if (userInfo.triiboId.includes('@anonymous')) {
      setIsAnonymous(true);
    }

    const currentDate = new Date();

    const GetFeed = async () => {
      const userRelationships = await getRelationshipsIds(userInfo.uId);
      const feed = await getFeedPosts(
        userInfo.uId,
        userInfo?.keyWordsSetLimit,
        userInfo?.orgs,
        userRelationships?.result,
        currentDate.getTime(),
        10
      );

      const formatDataFeed = feed.result.map((post) => {
        const currentDate = moment();
        const postDate = moment(post.creationDate);
        const difference = currentDate.diff(postDate);
        const formatDate = moment.duration(difference).humanize();

        return {
          ...post,
          postDate: formatDate,
          postUrlRedirect: ActionButtonUrl(post),
          isPost: true,
        };
      });

      setFeed(formatDataFeed);
    };

    GetFeed();
    // eslint-disable-next-line
  }, []);

  const GetMorePosts = async () => {
    const lastPost = feed.reduce(function (a, b) {
      return moment(a.creationDate).isAfter(moment(b.creationDate)) ? b : a;
    });

    const userRelationships = await getRelationshipsIds(userInfo.uId);
    const newfeed = await getFeedPosts(
      userInfo.uId,
      userInfo?.keyWordsSetLimit,
      userInfo?.orgs,
      userRelationships?.result,
      lastPost.creationDate,
      10
    );

    if (newfeed.result.length > 0) {
      setHasMore(true);
      const formatDataFeed = newfeed.result.map((post) => {
        const currentDate = moment();
        const postDate = moment(post.creationDate);
        const difference = currentDate.diff(postDate);
        const formatDate = moment.duration(difference).humanize();

        return {
          ...post,
          postDate: formatDate,
          postUrlRedirect: ActionButtonUrl(post),
        };
      });

      setFeed((prev) => [...prev, ...formatDataFeed]);
    } else {
      setHasMore(false);
    }
  };

  const ActionButtonUrl = (postInfos) => {
    const data = {
      action: postInfos.action.type,
      url: postInfos.appFilter.url,
      itemId: postInfos.appFilter.itemId,
      postId: postInfos.id,
    };

    const url = formatPostUrl(data);
    return url;
  };

  return (
    <>
      {isOpenModalLogin && <LoginModal openState={isOpenModalLogin} />}
      {feed.length < 1 ? (
        <div className="loading-content" style={{ textAlign: 'center' }}>
          <CircularProgress />
        </div>
      ) : (
        <InfiniteScroll
          dataLength={feed.length}
          next={GetMorePosts}
          hasMore={hasMore}
          loader={<LoadingLists />}
        >
          <S.FeedContainer>
            {feed.map((post) => (
              <S.CardPost key={post.id}>
                <S.CardHeader>
                  <S.CardLogo
                    src={
                      cfac22('STORAGE_URL') + encodeURIComponent(post.sender.logo) + '?alt=media'
                    }
                  />
                  <h3>{post.sender.name}</h3>
                </S.CardHeader>
                <S.CardImage
                  src={cfac22('STORAGE_URL') + encodeURIComponent(post.image) + '?alt=media'}
                />
                {post.action && (
                  <>
                    {post.action.type === 'url' ||
                    post.action.type === 'browser' ||
                    post.action.type === 'webview' ? (
                      isAnonymous ? (
                        <S.CardActionButton
                          style={{
                            marginLeft: 'auto',
                          }}
                          onClick={() => {
                            trackEventMatomoElementId('ListaDePosts', 'tocar', 'botão', post.id);
                            setIsOpenModalLogin(true);
                          }}
                        >
                          {post.action.label}
                        </S.CardActionButton>
                      ) : (
                        <a
                          href={post.postUrlRedirect}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            marginLeft: 'auto',
                          }}
                        >
                          <S.CardActionButton
                            onClick={() =>
                              trackEventMatomoElementId('ListaDePosts', 'tocar', 'botão', post.id)
                            }
                          >
                            {post.action.label}
                          </S.CardActionButton>
                        </a>
                      )
                    ) : (
                      <Link
                        to={{
                          pathname: post.postUrlRedirect.split('?')[0],
                          search: post.postUrlRedirect.split('?')[1],
                        }}
                        state={post}
                        style={{
                          marginLeft: 'auto',
                        }}
                      >
                        <S.CardActionButton
                          onClick={() =>
                            trackEventMatomoElementId('ListaDePosts', 'tocar', 'botão', post.id)
                          }
                        >
                          {post.action.label}
                        </S.CardActionButton>
                      </Link>
                    )}
                  </>
                )}

                <S.CardContent>
                  <h3>{post.title}</h3>
                  <S.Description>{post.message}</S.Description>
                  <span>{post.postDate}</span>
                </S.CardContent>
              </S.CardPost>
            ))}
          </S.FeedContainer>
        </InfiniteScroll>
      )}
    </>
  );
}
